/*
* @author 友人a丶
* @date 
* 内置主题
* */
import {useLocalStorage} from "@vueuse/core";
import {watch} from "vue";
import {applyCSSVariables} from "@/common";
import {ConfigProvider} from "ant-design-vue";


/**
 * 内置主题
 */
export const themes = [
    {name: "默认", color: "rgb(0, 107, 230)"},
    {name: "紫罗兰", color: "rgb(113, 102, 240)"},
    {name: "樱花粉", color: "rgb(232, 74, 108)"},
    {name: "柠檬黄", color: "rgb(239, 189, 72)"},
    {name: "天蓝色", color: "rgb(78, 105, 253)"},
    {name: "浅绿色", color: "rgb(11, 208, 146)"},
    {name: "锌色灰", color: "rgb(63, 63, 70)"},
    {name: "深绿色", color: "rgb(13, 148, 150)"},
    {name: "深蓝色", color: "rgb(9, 96, 190)"},
    {name: "橙黄色", color: "rgb(193, 66, 11)"},
    {name: "玫瑰红", color: "rgb(187, 27, 27)"},
    {name: "中性色", color: "rgb(64, 64, 64)"},
    {name: "石板灰", color: "rgb(52, 66, 86)"},
    {name: "中灰色", color: "rgb(56, 66, 82)"}
].map((item) => {
    return {

        name: "默认",
        primaryColor: item.color,
        linkColor: item.color,
        primaryHover: "#f7f8fa",
        adminHeaderBgcolor: "white",
        adminMenuColor: "#303133",
        adminSiderBg: "#ffffff",
        adminLayoutContent: "#f2f3f5",
        sidebarHoverBgColor: "#f2f3f5",
        cardBgColor: "#f2f3f5",
        adminHeaderColor: "#000000d9",
        adminHeaderBorder: "#e5e6eb",
        sidebarHoverColor: item.color,
    };
});


/**
 * 开始动态主题监听
 */
export function dynamicTheme() {
    /* 主题 */
    const theme = useLocalStorage('theme', themes[0]);

    /* 监听主题变化 */
    watch(() => theme.value, () => {

        /* antd */
        ConfigProvider.config({
            theme: Object.assign({
                primaryColor: '#165dff', // 全局主色
                linkColor: '#165dff', // 链接色
            }, theme.value)
        });

        /* 自定义 */
        applyCSSVariables(Object.assign({
            primaryColor: '#165dff', // 全局主色
            linkColor: '#165dff', // 链接色
        }, theme.value), 'theme');

    }, {
        deep: true,
        immediate: true
    })

}